module.exports = __webpack_public_path__ + "assets/img/ticket_success.80f90bb8.png";